<template>
    <div class="Intelligence IntelligenceCom">
        <!-- <MyHeader title="人工智能超算中心可视化大屏" /> -->
        <div class="page-left flex justify-content-between">
            <div class="page-1">
                <Part1 />
                <Part2 />
                <Part3 />
            </div>
            <div class="page-2">
                <Part4 />
                <Part5 />
                <Part6 />
            </div>
        </div>
        <div class="page-center">
            <!-- <TopTitle class="mt-150"/> -->
            <MyNumber class="disNumber" style="transform:scale(0.8);"/>
            <MyCenter class="mt-100"/>
        </div>
        <div class="page-right flex justify-content-between">
            <div class="page-3">
                <Part9 />
                <Part7 />
                <Part8 />
                <!-- <Part4 />
                <Part5 />
                <Part6 /> -->
            </div>
            <div class="page-4">
                <Part10 />
                <Part11 />
                <Part12 />
            </div>
        </div>
    </div>
</template>

<script>
import MyHeader from './../../components/myHeader.vue'
import MyCenter from './center.vue'
import Part1 from './../../components/IntelligenceCom/part-1.vue'
import Part2 from './../../components/IntelligenceCom/part-2.vue'
import Part3 from './../../components/IntelligenceCom/part-3.vue'
import Part4 from './../../components/IntelligenceCom/part-5.vue'
import Part5 from './../../components/IntelligenceCom/part-4.vue'
import Part6 from './../../components/IntelligenceCom/part-6.vue'
import Part7 from './../../components/IntelligenceCom/part-7.vue'
import Part8 from './../../components/IntelligenceCom/part-8.vue'
import Part9 from './../../components/IntelligenceCom/part-9.vue'
import Part10 from './../../components/IntelligenceCom/part-10.vue'
import Part11 from './../../components/IntelligenceCom/part-11.vue'
import Part12 from './../../components/IntelligenceCom/part-12.vue'
import TopTitle from './../../components/TopTitle.vue'
import MyNumber from '../../components/myNumbers.vue'

export default {
    components: {
        // MyHeader,
        MyCenter,
        Part1,
        Part2,
        Part3,
        Part4,
        Part5,
        Part6,
        Part7,
        Part8,
        Part9,
        Part10,
        Part11,
        Part12,
        // TopTitle,
        MyNumber,
    },
    data() {
        return {
            intervalNum: 60,
            pageInterval: null,
			end:false,
        }
    },
    mounted() {
		this.$EventBus.$on('isActiveEnd', (isActiveEnd) => {
			if (isActiveEnd) {
				this.end = false;
			} else {
				this.end = true;
			}
		})

		if(this.pageInterval) {
			clearInterval(this.pageInterval)
			this.pageInterval = null
		}
		// if(sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
		this.pageInterval = setInterval(() => {
			if(this.end) return;
			this.intervalNum--
            if(localStorage.getItem('IntervalStop') == 'stop') {
							return
						}
			if(this.intervalNum < 0 ) {
				this.$router.replace({
					path: 'exposition',
				})
			}
		}, 1000)
    },
    destroyed() {
        clearInterval(this.pageInterval)
    }
}
</script>

<style lang="scss" scoped>
@import './../../components/comm.scss';

.disNumber{
    position: absolute;
    top: 450px;
}

</style>